<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'over'">
        <mat-toolbar color="white">
            <mat-toolbar-row class="desktop">
               <!--  <img src="assets/images/generico/logo.png" class="logo_nav_bar"> -->
                <span style="cursor: pointer;" (click)="getForm('0','', true)" class="titulo_nav_bar">Formularios</span>
                <span class="spacer"></span>
                <div class="circulo online " style="margin-right: 5px"></div>
                <div><span style="font-size: 15px">Online</span></div>
                <div class="circulo offline" style="margin-left: 15px; margin-right: 5px"></div>
                <div><span style="font-size: 15px; margin-right: 5px">Presencial</span></div>
                <button mat-icon-button arial-label="Cerrar menu" (click)="drawer.toggle()">
                    <mat-icon class="icon">clear</mat-icon>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row class="mobile">
                <!-- <img src="assets/images/generico/logo.png" class="logo_nav_bar"> -->
                <span style="cursor: pointer;" (click)="getForm('0','', true)" class="titulo_nav_bar">Formularios</span>
                <span class="spacer"></span>
                <button mat-icon-button arial-label="Cerrar menu" (click)="drawer.toggle()">
                    <mat-icon class="icon">clear</mat-icon>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row class="mobile">
                <div class="circulo online " style="margin-right: 5px"></div>
                <div><span style="font-size: 15px">Online</span></div>
                <span class="spacer"></span>
                <div class="circulo offline" style="margin-left: 15px; margin-right: 5px"></div>
                <div><span style="font-size: 15px; margin-right: 5px">Presencial</span></div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-nav-list style="padding-top:0px !important">

            <mat-accordion>

                <div *ngFor=" let materia of materias; let i = index ">
                    <mat-expansion-panel [expanded]="materia.num == expandedItem" *ngIf="materia.active">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon [svgIcon]="materia.icon" class="iconCustom"></mat-icon><strong>
                                    {{materia.name}}</strong>
                            </mat-panel-title>

                        </mat-expansion-panel-header>
                        <div *ngFor=" let form of materia.forms; let ii = index">
                            <!-- {{form.name}} -->
                            <a *ngIf="form.active" mat-list-item (click)="getForm(form.num,  form.name, form.online); ">
                                <div class="cuadrado online">{{form.num}}</div>
                                <h5 style="width: 95%">{{form.name }}</h5>
                            </a>
                        </div>
                    </mat-expansion-panel>
                </div>

            </mat-accordion>
        </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content>
        <mat-toolbar class="icon_muni_1">
            <mat-toolbar-row>
                <span><img src="assets/images/generico/logo.png" class="logo"> </span>
                <span class="col-md-4">Expedientes - Municipalidad
                    de {{ nombreMuni }}</span>
                <div align="center" class="col-md-4">
                </div>
            </mat-toolbar-row>
            <mat-toolbar-row>

                <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>

                <span class="spacer"></span>

                <div class="col-sm-4 align-right" align="right">
                    <span class="user-name" *ngIf="identity || token && false">
                        {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
                    </span>
                    <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                        arial-label="Información del perfil">
                        <mat-icon class="icon">person</mat-icon>
                        <mat-icon *ngIf="nombreMuni!='Lo Barnechea'" class="icon"
                            [matBadge]="contador_definitivo == 0 ? '' : contador_definitivo" matBadgeColor="warn">person
                        </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">

                        <!-- <button mat-menu-item (click)="getForm('0','', true)">
                            <mat-icon class="iconcolor">work</mat-icon>
                            <span>Inicio</span>
                        </button> -->
                        <button mat-menu-item (click)="getSolicitudes();">
                            <mat-icon class="iconcolor">feedback</mat-icon>
                            <span>Mis Solicitudes</span>
                        </button>

                        <button *ngIf="false" mat-menu-item (click)="verBorradores()">
                            <mat-icon class="iconcolor">history</mat-icon>
                            <span>Mis Borradores</span>
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <mat-icon class="iconcolor">exit_to_app</mat-icon>
                            <span>Cerrar sesión</span>
                        </button>
                    </mat-menu>
                    <button mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio" (click)="back()">
                        <mat-icon class="icon">home</mat-icon>
                    </button>
                </div>

            </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="icon_muni_2 responsive_elemento" color="white">


            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <span><img src="assets/images/generico/logo.png" class="logo"> </span>
            <span class="col-md-4 ">Expedientes - Municipalidad
                de {{ nombreMuni }}</span>
            <div align="center" class="col-md-4">
            </div>
            <div class="col-md-4" align="right">
                <span class="user-name" *ngIf="identity || token && false">
                    {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
                </span>
                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                    arial-label="Información del perfil">
                    <mat-icon class="icon" [matBadge]="contador_definitivo == 0 ? '' : contador_definitivo"
                        matBadgeColor="warn">person</mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                    <!-- <button mat-menu-item (click)="getForm('0','', true)">
                        <mat-icon class="iconcolor">work</mat-icon>
                        <span>Inicio</span>
                    </button> -->
                    <button mat-menu-item (click)="getSolicitudes();">
                        <mat-icon class="iconcolor">feedback</mat-icon>
                        <span>Mis Solicitudes</span>
                    </button>

                    <button *ngIf="false" mat-menu-item (click)="verBorradores()">
                        <mat-icon class="iconcolor">history</mat-icon>
                        <span>Mis Borradores</span>
                    </button>
                    <button mat-menu-item (click)="logout()">
                        <mat-icon class="iconcolor">exit_to_app</mat-icon>
                        <span>Cerrar sesión</span>
                    </button>
                </mat-menu>
                <button mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio" (click)="back()">
                    <mat-icon class="icon">home</mat-icon>
                </button>
            </div>

        </mat-toolbar>

        <section class="fondo">
            <div class="container">
                <div class="board">

                    <msw-navbar *ngIf="form | async as p" [form]="p.form" [title]="p.title"></msw-navbar>
                    <page-instructions></page-instructions>

                </div>
            </div>
        </section>
    </mat-sidenav-content>

</mat-sidenav-container>
<section>
    <div class="ftr">
        <p class="ftr-txt">
            {{footer}}
            <br>
            <a [href]="webUrl" target="_blank"> {{web}}</a>
        </p>
    </div>
</section>



<ng-template #mailSave>
    <h2 mat-dialog-title>Su correo no está en nuestros registros</h2>
    <mat-dialog-content>
        <p>Su registro no cuenta con correo asociado. Por favor, ingrese su dirección de email para poder continuar</p>
        <form [formGroup]="mail">
            <mat-form-field class="input-form">
                <input matInput placeholder="Correo" type="email" name="correo" formControlName="email"
                    onpaste="return false;" onCopy="return false" onCut="return false" />
                <mat-error *ngIf="mail.controls.email.errors?.required">Email requerido
                </mat-error>
                <mat-error *ngIf="mail.controls.email.errors?.pattern">Formato incorrecto.
                    Ej:
                    correo@servidor.dominio. </mat-error>
                <mat-error *ngIf="mail.controls.email.errors?.maxlength">Excede el máximo de
                    caracteres
                    (50). </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" id="ingreso_mail" [disabled]="mail.status == 'INVALID'"
            (click)="submitMail()">Aceptar </button>
    </mat-dialog-actions>
</ng-template>